// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__UdOx-","delete":"Button_delete__3m301"};